import React from "react";
import { Button } from "react-md";
import errorImg from "../../../../../../../assets/icons/payment/error_red_exclamation.svg";

const ErrorInCreatingAppointment = ({ onClose, errorText }) => {
  return (
    <div
      className="pld-screen pld-method-container"
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      {/* ERROR IMAGE */}
      <div style={{ marginTop: "25px" }}>
        <img src={errorImg} alt="error" height="80px" />
      </div>

      {/* NOTE BOX */}
      <div className="pld-note-container" style={{ marginTop: "25px" }}>
        <div className="pld-note-box">
          <span className="pld-bold">Error in creating appointment </span>
        </div>
      </div>

      <div style={{ marginTop: "10px" }}>{errorText}</div>

      {/* BUTTON */}
      <div className="pld-center" style={{ marginTop: "10px" }}>
        <Button raised className="zy-btn-orange pld-main-btn" onClick={onClose}>
          Okay
        </Button>
      </div>
    </div>
  );
};

export default ErrorInCreatingAppointment;
